export default __webpack_public_path__ + "static/media/SourceSansPro-SemiBold.0bc09b3d.eot";